import { useEffect } from 'react';
import { FiX } from 'react-icons/fi';

/**
 * Lightweight full-screen modal for viewing an image (e.g. evidence photo).
 * Closes on backdrop click or Escape. Props: src, alt, onClose.
 */
export function ImageModal({ src, alt, onClose }) {
  useEffect(() => {
    const handleEsc = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  if (!src) return null;

  return (
    <div
      className="image-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={alt || 'View image'}
    >
      <button
        type="button"
        onClick={onClose}
        className="image-modal-close"
        aria-label="Close"
      >
        <FiX size={32} />
      </button>
      <img
        src={src}
        alt={alt || 'Evidence'}
        className="image-modal-img"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
